import axios from 'axios';
import { ConfigObj } from './type';
import { getEnvConfig } from './env-configs';

/* eslint-disable no-underscore-dangle */
export class Config {
  static _APP_URL: string;

  static _API_GATEWAY_URL: string;

  static _ASSETS_URL: string;

  static _AUTH_URL: string;

  static _HYLIA_API_URL: string;

  static _HYLIA_ASSETS_URL: string;

  static _HYLIA_WEB_URL: string;

  static _MAMI_URL: string;

  static _SHOULD_TRACK_MAMI_EVENTS?: string;

  static _PAPI_URL: string;

  static _PEARMD_ASSETS_URL: string;

  static _PEAR002A_ASSETS_URL: string;

  static _SOMRYST_WEB_URL: string;

  static _WEAVER_API_URL: string;

  static _DD_APPLICATION_ID: string;

  static _DD_CLIENT_TOKEN: string;

  static _DD_ENV: string;

  static _DD_TRACK_USER_INTERACTIONS: string;

  static _DD_TRACK_RESOURCES: string;

  static _DD_TRACK_LONG_TASKS: string;

  static _NODE_ENV: string;

  static _BUILD_ENV: string;

  static async fetchConfig(): Promise<ConfigObj> {
    const localConfig = getEnvConfig();
    if (localConfig) return localConfig;
    try {
      const res = await axios.get('/config.json');
      return res.data;
    } catch (error) {
      console.log('Unable to load config.json');
      throw error;
    }
  }

  static async loadConfig(): Promise<boolean> {
    const config = await Config.fetchConfig();
    Config._API_GATEWAY_URL = config.API_GATEWAY_URL;
    Config._APP_URL = config.APP_URL;
    Config._AUTH_URL = config.AUTH_URL;
    Config._HYLIA_API_URL = config.HYLIA_API_URL;
    Config._HYLIA_ASSETS_URL = config.HYLIA_ASSETS_URL;
    Config._HYLIA_WEB_URL = config.HYLIA_WEB_URL;
    Config._MAMI_URL = config.MAMI_URL;
    Config._SHOULD_TRACK_MAMI_EVENTS = config?.SHOULD_TRACK_MAMI_EVENTS;
    Config._PAPI_URL = config.PAPI_URL;
    Config._PEARMD_ASSETS_URL = config.PEARMD_ASSETS_URL;
    Config._PEAR002A_ASSETS_URL = config.PEAR002A_ASSETS_URL;
    Config._SOMRYST_WEB_URL = config.SOMRYST_WEB_URL;
    Config._WEAVER_API_URL = config.WEAVER_API_URL;
    Config._DD_APPLICATION_ID = config.DD_APPLICATION_ID;
    Config._DD_CLIENT_TOKEN = config.DD_CLIENT_TOKEN;
    Config._DD_ENV = config.DD_ENV;
    Config._DD_TRACK_USER_INTERACTIONS = config.DD_TRACK_USER_INTERACTIONS;
    Config._DD_TRACK_RESOURCES = config.DD_TRACK_RESOURCES;
    Config._DD_TRACK_LONG_TASKS = config.DD_TRACK_LONG_TASKS;
    Config._NODE_ENV = process.env.NODE_ENV ?? '';
    Config._BUILD_ENV = config.BUILD_ENV;
    return true;
  }

  static get API_GATEWAY_URL() {
    return Config._API_GATEWAY_URL;
  }

  static set API_GATEWAY_URL(str: string) {
    Config._API_GATEWAY_URL = str;
  }

  static get APP_URL() {
    return Config._APP_URL;
  }

  static set APP_URL(str: string) {
    Config._APP_URL = str;
  }

  static get AUTH_URL() {
    return Config._AUTH_URL;
  }

  static set AUTH_URL(str: string) {
    Config._AUTH_URL = str;
  }

  static get HYLIA_API_URL() {
    return Config._HYLIA_API_URL;
  }

  static get HYLIA_ASSETS_URL() {
    return Config._HYLIA_ASSETS_URL;
  }

  static set HYLIA_ASSETS_URL(str: string) {
    Config._HYLIA_ASSETS_URL = str;
  }

  static get HYLIA_WEB_URL() {
    return Config._HYLIA_WEB_URL;
  }

  static set HYLIA_WEB_URL(str: string) {
    Config._HYLIA_WEB_URL = str;
  }

  static get MAMI_URL() {
    return Config._MAMI_URL;
  }

  static set MAMI_URL(str: string) {
    Config._MAMI_URL = str;
  }

  static get SHOULD_TRACK_MAMI_EVENTS() {
    return Config._SHOULD_TRACK_MAMI_EVENTS;
  }

  static set SHOULD_TRACK_MAMI_EVENTS(str: string | undefined) {
    Config._SHOULD_TRACK_MAMI_EVENTS = str;
  }

  static get PAPI_URL() {
    return Config._PAPI_URL;
  }

  static set PAPI_URL(str: string) {
    Config._PAPI_URL = str;
  }

  static get PEARMD_ASSETS_URL() {
    return Config._PEARMD_ASSETS_URL;
  }

  static set PEARMD_ASSETS_URL(str: string) {
    Config._PEARMD_ASSETS_URL = str;
  }

  static get PEAR002A_ASSETS_URL() {
    return Config._PEAR002A_ASSETS_URL;
  }

  static set PEAR002A_ASSETS_URL(str: string) {
    Config._PEAR002A_ASSETS_URL = str;
  }

  static get SOMRYST_WEB_URL() {
    return Config._SOMRYST_WEB_URL;
  }

  static set SOMRYST_WEB_URL(str: string) {
    Config._SOMRYST_WEB_URL = str;
  }

  static get WEAVER_API_URL() {
    return Config._WEAVER_API_URL;
  }

  static set WEAVER_API_URL(str: string) {
    Config._WEAVER_API_URL = str;
  }

  static get DD_APPLICATION_ID(): string {
    return Config._DD_APPLICATION_ID;
  }

  static set DD_APPLICATION_ID(str: string) {
    Config._DD_APPLICATION_ID = str;
  }

  static get DD_CLIENT_TOKEN(): string {
    return Config._DD_CLIENT_TOKEN;
  }

  static set DD_CLIENT_TOKEN(str: string) {
    Config._DD_CLIENT_TOKEN = str;
  }

  static get DD_ENV(): string {
    return Config._DD_ENV;
  }

  static set DD_ENV(str: string) {
    Config._DD_ENV = str;
  }

  static get DD_TRACK_USER_INTERACTIONS(): string {
    return Config._DD_TRACK_USER_INTERACTIONS;
  }

  static set DD_TRACK_USER_INTERACTIONS(str: string) {
    Config._DD_TRACK_USER_INTERACTIONS = str;
  }

  static get DD_TRACK_RESOURCES(): string {
    return Config._DD_TRACK_RESOURCES;
  }

  static set DD_TRACK_RESOURCES(str: string) {
    Config._DD_TRACK_RESOURCES = str;
  }

  static get DD_TRACK_LONG_TASKS(): string {
    return Config._DD_TRACK_LONG_TASKS;
  }

  static set DD_TRACK_LONG_TASKS(str: string) {
    Config._DD_TRACK_LONG_TASKS = str;
  }

  static get NODE_ENV() {
    return Config._NODE_ENV;
  }

  static set NODE_ENV(str: string) {
    Config._NODE_ENV = str;
  }

  static get BUILD_ENV() {
    return Config._BUILD_ENV;
  }

  static set BUILD_ENV(str: string) {
    Config._BUILD_ENV = str;
  }
}
/* eslint-enable no-underscore-dangle */
